import { getProperDate } from '@/utils/changeDate';
import { defineStore } from 'pinia';

export const useNewDataFormCargoPickUpStore = defineStore({
  id: 'newDataFormCargoPickUp',
  state: () => ({
    applicationCargoPickup: {
      isCargoPickup: true,
      addressCargoPickup: '',
      pickupDate: '',

      cargoStartTimePickup: '09:00',
      cargoEndTimePickup: '18:00',
      startTimeLunchBreak: '12:00',
      endTimeLunchBreak: '13:00',

      deliveryDate: '',

      cargoStartTimeDelivery: '09:00',
      cargoEndTimeDelivery: '18:00',
      startTimeLunchBreakDelivery: '12:00',
      endTimeLunchBreakDelivery: '13:00',

      deliveryToTheAddress: false,
      addressConsignee: '',

      dataOnTheDriver: '',
      comment: '',
    },

    fetchedDeliveryTimeIntervals: [],

    sender: {
      cityFrom: null,
      senderZaborType: '',
      senderType: false,
      addressCargoPickup: '',
      pickUpDate: '',
      detailsPickup: '',
      cargoTimePickup: '',
      comment: '',

      whoPaysZabor: '',
      typeOfPaymentZabor: '',

      innSender: '',
      name: '',
      fioSender: '',
      phoneSender: '',
      emailSender: '',

      powerOfAttorney: false,
      typePowerOfAttorney: '',

      dataForTheDriver: false,
      sendTo: '',
    },

    consignee: {
      cityTo: '',
      consigneeType: false,

      addressCargoDelivery: '',
      detailsDelivery: '',

      consigneeDeliveryType: '',
      cargoTimeDelivery: '',

      whoPaysCargoDelivery: '',
      typeOfPaymentCargoDelivery: '',

      innConsignee: '',
      name: '',
      fioConsignee: '',
      phoneConsignee: '',
      emailConsignee: '',
    },

    thirdPerson: {
      cargoTransportationCustomer: 'Отправитель',
      typeThirdPerson: false,

      innThirdPerson: '',
      name: '',
      fioThirdPerson: '',
      phoneThirdPerson: '',
      emailThirdPerson: '',

      whoPaysCargoTransportation: '',
      typeOfPaymentCargoTransportation: '',
    },
    fetchedSuitableOffices: {
      pickUp: [],
      delivery: [],
    },

    fetchedAvailablePickupTime: [],

    fetchedExtraPackaging: [],

    cachedFetchedExtraPackaging: null,

    cargoInformation: {
      typeOfCargo: { id: 1, title: 'Стандарт' },
      numberOfIdenticalLoads: 1,
      cargoVolume: null,
      cargoWeight: null,
      cargoDimensions: {
        length: null,
        width: null,
        height: null,
      },
      sizeOfCargoCylinder: {
        diameter: null,
        height: null,
      },
      additionalPackaging: false,
      typeOfPackaging: [],
      natureOfCargo: null,
      cargoCost: 3000,

      warmPlace: false,

      cashOnDelivery: false,
      cashOnDeliverySum: '',

      cargoRedemption: false,
      cargoRedemptionSum: '',
      whoPaysTheRansom: '',

      returnOfDocuments: false,

      whoPaysForCargoExtraPacking: '',
      typeOfPaymentForCargoExtraPacking: '',
    },

    services: {
      powerOfAttorney: false,
      typePowerOfAttorney: '',
      dataForTheDriver: false,
      sendTo: '',
      cashOnDelivery: false,
      cashOnDeliverySum: null,
      cargoRedemption: false,
      cargoRedemptionSum: null,
      whoPaysTheRansom: '',
      warmPlace: false,
      returnOfDocuments: false,
      isSenderInn: false,
    },

    utils: {
      canGetDelivery: false,
    },

    payment: {
      whoPaysForCargoDelivery: '',
      typeOfPaymentForCargoDelivery: '',
      whoPaysForCargoPickup: '',
      typeOfPaymentForCargoPickup: '',
      whoPaysForCargoTransportation: '',
      typeOfPaymentForCargoTransportation: '',
      whoPaysForCargoExtraPacking: '',
      typeOfPaymentForCargoExtraPacking: '',
      isAgreeDataProcessing: false,
      isAgreeEmailMailing: false,
    },

    requestPendingForPackaging: false,

    calculator: {
      isCargoPickup: 'Сдать на склад',
      isDelivery: 'Забрать на складе',
    },
    applicationTimeIsOver: '13:00',

    passedValidTab: 0,
  }),
  getters: {
    getIsValidStandard(state) {
      return Boolean(
        state.cargoInformation.cargoDimensions.height && state.cargoInformation.cargoDimensions.width && state.cargoInformation.cargoDimensions.length && state.cargoInformation.cargoWeight
      );
    },
    getIsValidCylinder(state) {
      return Boolean(state.cargoInformation.sizeOfCargoCylinder.diameter && state.cargoInformation.sizeOfCargoCylinder.height && state.cargoInformation.cargoWeight);
    },

    getRequiredExtraPackaging(state) {
      return state.fetchedExtraPackaging.filter((el) => el.isRequired);
    },

    getAvailableExtraPackaging(state) {
      return state.fetchedExtraPackaging.filter((el) => !el.isRequired);
    },

    getAvailableDates(state) {
      return state.fetchedAvailablePickupTime.map((el) => el.date);
    },
    getAvailableTimePeriods(state) {
      return (selectedDate) => {
        const availablePeriods = state.fetchedAvailablePickupTime.find((el) => getProperDate(selectedDate) === el.date);

        return availablePeriods?.pickUpTimePeriods || [];
      };
    },

    getCheckRequiredSelected(state) {
      const fetchHasRequired = Boolean(state.fetchedExtraPackaging.find((el) => el.isRequired));
      if (fetchHasRequired) {
        const selectedHasRequired = Boolean(state.cargoInformation.typeOfPackaging.find((el) => el.isRequired));
        if (!selectedHasRequired) {
          return false;
        }
      }
      return true;
    },

    getApplicationTimeIsOver(state) {
      return state.applicationTimeIsOver;
    },
    getDayToDayAllowed(state) {
      const currentDate = new Date();
      const currentTimeFloat = currentDate.getHours() + currentDate.getMinutes() / 100;
      const currentFormTimeFloat = Number(state.getCheckingApplicationTimeIsOver.slice(0, 2)) + Number(state.getCheckingApplicationTimeIsOver.slice(3)) / 100;
      if (currentTimeFloat >= currentFormTimeFloat) {
        return false;
      }
      return true;
    },

    getCheckingApplicationTimeIsOver(state) {
      if (state.sender.cityFrom === 'Челябинск') {
        if (state.cargoInformation.cargoWeight > 30) {
          const applicationTimeIsOver = '12:00';
          return applicationTimeIsOver;
        }
        const applicationTimeIsOver = '15:00';
        return applicationTimeIsOver;
      }
      if (state.sender.cityFrom === 'Екатеринбург') {
        const applicationTimeIsOver = '01:00';
        return applicationTimeIsOver;
      }
      const applicationTimeIsOver = '13:00';
      return applicationTimeIsOver;
    },

    getThirdPersonAvailable(state) {
      return state.thirdPerson.cargoTransportationCustomer === 'Третье лицо';
    },
  },
  actions: {
    updateApplicationTimeIsOver() {
      this.applicationTimeIsOver = this.getCheckingApplicationTimeIsOver;
    },
  },
});
